import React from "react";
import { useAboutUsModel } from "../aboutUsModel";
import { SearchTypeEnum, ISearchValue } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useAboutUsModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "公司名称",
            fieldName: "name",
        }
    ]

    return (
        <YhPageHeader
            title="公司简介管理"
            justify="end"
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}